import { render, staticRenderFns } from "./Appbar.vue?vue&type=template&id=3123b286&scoped=true&"
import script from "./Appbar.vue?vue&type=script&lang=js&"
export * from "./Appbar.vue?vue&type=script&lang=js&"
import style0 from "./Appbar.vue?vue&type=style&index=0&id=3123b286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123b286",
  null
  
)

export default component.exports